import React from 'react';
import ResursLogoImg from '../images/resurs.svg';
import styles from './ResursLogo.module.scss';

function ResursLogo() {
  return <img src={ResursLogoImg} alt="Resurs Bank" className={styles.Logo} />;
}

export default ResursLogo;
